import { useQuery } from 'react-query'
import { getOrderDetails } from '../../services/api'

export function useGetOrderDetails(orderId) {
  return useQuery(['orderHistoryDetail', orderId], () =>
    getOrderDetails(orderId)
  )
}
